module.exports = __webpack_public_path__ + "static/img/visual_mo.4420654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010224/visual_mo.png
// module id = 3hLD
// module chunks = 10